/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */


import { type QueryFunctionContext } from '@tanstack/react-query';

import { recordSnapshotLastSeq } from '../../nats/snapshot-seq-store.js';

import { fetchWithHttpTelemetry } from '../../transport/http-request.js';

import { throwHttpError } from '../../core/http-error.js';

import type { GetMarketConfigsRow } from '../openapi-types.gen.js';

import type { EntityKeyFactory, HookSpec } from '../../types/HookSpec.js';
import type { JsonSerialisableArgs } from '../../types/JsonSerialisableArgs.js';


// ─── useGetMarketConfigs ────────────────────────────────────────────────────────────

export interface useGetMarketConfigsArgs {  }


async function _useGetMarketConfigsQueryFn(
  args: useGetMarketConfigsArgs,
  ctx: QueryFunctionContext,
): Promise<GetMarketConfigsRow | null> {
  const url = '/v1/market-configs';
  const params = new URLSearchParams();
  // Fixed response DTO — no caller-provided field projection.
  const sep = url.includes('?') ? '&' : '?';
  const full = params.size > 0 ? `${url}${sep}${params.toString()}` : url;
  const res = await fetchWithHttpTelemetry({
    operationName: 'useGetMarketConfigs',
    routeTemplate: '/v1/market-configs',
    requestKind: 'query',
    method: 'GET',
    url: full,
    signal: ctx.signal,
    init: {
      method: 'GET',
      credentials: 'include',
      headers: { Accept: 'application/json' },
      ...(ctx.signal !== undefined ? { signal: ctx.signal } : {}),
    },
  });
  // Public immutable catalogs must retain cached data on every HTTP failure.
  if (!res.ok) await throwHttpError('GET', full, res);
  const json = (await res.json()) as unknown;
  recordSnapshotLastSeq(ctx.queryKey, json);
  const data =
    json !== null && typeof json === 'object' && 'data' in json
      ? (json as { data: unknown }).data
      : json;
  return data as GetMarketConfigsRow;
}


const _useGetMarketConfigsFactory = Object.assign(
  (args: useGetMarketConfigsArgs) => ({
    queryKey: ['market-configs', 'detail'] as readonly unknown[],
    queryFn: (ctx: QueryFunctionContext) => _useGetMarketConfigsQueryFn(args, ctx),
    staleTime: Number.POSITIVE_INFINITY,
    refetchOnMount: false as const,
    refetchOnWindowFocus: false as const,
    refetchOnReconnect: false as const,
    retryOnMount: false as const,
    // structuralSharing kept ON (TanStack default). The codegen-emitted
    // applyEvent already preserves row references for unchanged rows;
    // structural sharing on top lets per-card `select` selectors
    // short-circuit when their row hasn't changed, avoiding cascade
    // re-renders of every list child on each patch.
    meta: {
      realtime: false,
      pollingManaged: true,
      specName: 'useGetMarketConfigs',
      viewerSensitive: false,
      persist: true,
    } as const,
  }),
  {
    __brand: 'EntityKeyFactory' as const,
    prefix: () => ['market-configs', 'detail'] as readonly unknown[],
  },
) as unknown as EntityKeyFactory<useGetMarketConfigsArgs, GetMarketConfigsRow>;


export const useGetMarketConfigsSpec = {
  __brand: 'HookSpec' as const,
  path: '/v1/market-configs',
  method: 'GET' as const,
  kind: 'detail' as const,
  mounting: { kind: 'singleton' as const, allowsPerEntity: false },
  entityKeys: { detail: _useGetMarketConfigsFactory },
  parseInput: (raw: unknown): useGetMarketConfigsArgs => raw as useGetMarketConfigsArgs,
  parseResponse: (raw: unknown): GetMarketConfigsRow => raw as GetMarketConfigsRow,
  specName: 'useGetMarketConfigs' as const,
  polling: { hasNats: false, intervalMs: false } as const,
  viewerSensitive: false as const,
  nonpersistent: false as const,
} as unknown as HookSpec<JsonSerialisableArgs, GetMarketConfigsRow>;
